import * as React from 'react';
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils';
var noop = function() {};
/**
 * Runs an effect once, when `condition` is true.
 */ export var useRunOnce = function(condition, effect) {
    var didRun = React.useRef(false);
    useEnhancedEffect(function() {
        if (didRun.current || !condition) {
            return noop;
        }
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};
